/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';

export class UnitCategory extends AbstractObject {
  name: string;
  typeId: uuid;
  constructor(o: Partial<UnitCategory> = {}) {
    super(o);
  }
}
